<chapps-sub-header [label]="Localization.NotificationsPerBuilding"></chapps-sub-header>
<div class="mt-4 mb-4">
  <div *ngIf="isLoading" class="flex-center m-4">
    <mdb-spinner  spinnerColor="blue"></mdb-spinner>
  </div>
  <div *ngIf="isListEmpty() && !isLoading" class="alert alert-light m-4" role="alert">
    {{ Localization.EmptyDataMessage | translate }}
  </div>
  <table *ngIf="!isListEmpty() && !isLoading" mdbTable class="details-table table-with-actions table-no-first-border mb-0"
         [striped]="true" [hover]="true">
      <thead>
        <tr>
          <th [translate]="Localization.Building"></th>
          <th class="text-center" [translate]="Localization.ProblemsPresent"></th>
          <th class="text-right" [translate]="Localization.DateOfLastProblem"></th>
          <th></th>
        </tr>
    </thead>
    <tbody>
    <tr mdbTableCol *ngFor="let item of list" class="clickable" (click)="goToNotificationsPage(item.buildingStructureId, item.application)">
      <td>{{item.label}} </td>
      <td class="text-center">{{item.numberOfOpenNotifications}}</td>
      <td class="text-right">{{ item.lastIssueDate | date: applicationConfig.DATE_FORMAT}}</td>
      <td class="text-center align-middle">
        <i class="fas fa-angle-right fa-lg"></i>
      </td>
    </tr>
    </tbody>
  </table>
</div>

